// extracted by mini-css-extract-plugin
export default {"root":"CustomHeader_root__03LRb","logo":"CustomHeader_logo__F6XE-","name":"CustomHeader_name__Dlp-3"};